module.exports = "https://cdn.hellotech.com/client-assets/computers_tablet_398ab8fba9576497073e2cd70e7d528c.png";